import sample_01 from './100_39297.jpg';
import sample_02 from './100_39305.jpg';

export const dynamicAllroundImpressions = {
    sample_02,
    sample_01,
};
